var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#434345",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    "data-color": "color-2",
    fill: "none",
    stroke: "#434345",
    strokeWidth: 2,
    x1: 7.6,
    y1: 10.5,
    x2: 16.4,
    y2: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    "data-color": "color-2",
    fill: "none",
    stroke: "#434345",
    strokeWidth: 2,
    x1: 7.6,
    y1: 13.5,
    x2: 16.4,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#434345",
    strokeWidth: 2,
    cx: 5,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#434345",
    strokeWidth: 2,
    cx: 19,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#434345",
    strokeWidth: 2,
    cx: 19,
    cy: 20,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c0f5392c847d5a2e48b2a38db8ee9c3a.svg";
export { ForwardRef as ReactComponent };